import { render, staticRenderFns } from "./StudentApprove.vue?vue&type=template&id=8727b114"
import script from "./StudentApprove.vue?vue&type=script&lang=js"
export * from "./StudentApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports